export default {
    title: "數據分析",
    tabs1: "表格分析",
    tabs2: "圖表分析",
    search1: "選擇時間",
    search2: "選擇商品",
    search3: "選擇子公司/分行",
    search4: "選擇部門",
    search5: "選擇人員",
    place1: "開始時間",
    place2: "結束時間",
    place3: "請選擇商品",
    place4: "請選擇子公司/分行",
    place5: "請選擇部門",
    place6: "請選擇人員",
    table1: "日期",
    table2: "分公司/分行",
    table3: "部門",
    table4: "下單員",
    table5: "訂單號",
    table6: "商品",
    table7: "品牌",
    table8: "商品編號",
    table9: "商品數量",
    table10: "商品單價",
    table11: "平均單價",
    table12: "地區",
    table13: "商品描述",
    table14: "行業平均單價",
    table15: "行業平均數量",
    table16: "澳門平均單價",
    table17: "澳門平均數量",
    downloadBtn: "下載表格",
    chartName1: "訂單量折線圖",
    chartName2: "訂單金額柱狀圖",
    yName1: "訂單量",
    yName2: "訂單金額",
    checkAll: "全選",
    form1: "選擇展示項",
    form2: "選擇時間",
    form3: "選擇子公司/分行",
    form4: "選擇部門",
    form5: "選擇人員",
    form6: "訂單號",
    form7: "選擇商品",
    form8: "品牌",
    form9: "行業",
    btn1: "查詢原始表格",
    btn2: "下載表格",
    error1: "您還未選擇展示項",
}